import { entries } from 'lodash';
import React from 'react';

import useIsMobile from 'hooks/use-is-mobile';

import Ai from './components/Ai';
import Cvss from './components/Cvss';
import Epss from './components/Epss';
import Ssvc from './components/Ssvc';

interface CvssValue {
    version: string;
    baseScore: number;
    vectorString: string;
    [key: string]: string | number | boolean;
}

interface SsvcValue {
    id: string;
    role: string;
    options: Record<string, string>[];
}

type MetricOf<T> = Array<{ source: string; value: T }>;

interface Props {
    metrics?: Record<string, MetricOf<CvssValue> | MetricOf<SsvcValue>>;
    epss?: { epss: number; percentile: number }[];
    aiScore?: { value: number; uncertanity: number };
}

const Metrics: React.FC<Props> = ({ metrics, aiScore, epss }) => {
    const isMobile = useIsMobile();

    return (
        <>
            {aiScore ? <Ai aiScore={aiScore} diagram={isMobile === false} /> : null}
            {entries(metrics).map(([field, value]) =>
                field.startsWith('cvss') ? <Cvss key={field} field={field} data={value as MetricOf<CvssValue>} /> : null
            )}
            {epss ? <Epss epss={epss} /> : null}
            {entries(metrics).map(([field, value]) =>
                field.startsWith('ssvc') ? <Ssvc key={field} field={field} data={value as MetricOf<SsvcValue>} /> : null
            )}
        </>
    );
};

export default Metrics;
